import { useMedia } from 'react-use';

import { laptopAndAbove } from '#src/style/mediaQuery.ts';

export const useIsLaptop = () => useMedia(laptopAndAbove);
